import { isEmptyObject } from "utilities/common";

export function promoValidation(fields){
    const errors = {};
    if(!fields.name || fields.name.trim()===''){
        errors.name = 'Name is required'
    }
    // Usage Limit and Usage Limit Per User: no validation (optional fields)
    // if (fields.usageLimit === "" || fields.usageLimit == null || Number(fields.usageLimit) < 1) {
    //     errors.usageLimit = "Total usage limit is required and must be at least 1";
    // }
    // if (fields.usageLimitPerUser === "" || fields.usageLimitPerUser == null || Number(fields.usageLimitPerUser) < 1) {
    //     errors.usageLimitPerUser = "Per-user usage limit is required and must be at least 1";
    // }
    // if (fields?.code?.length === 0) {
    //   errors.code ='Atleast one promo code is required' ;
    // }
    const codes = (fields.code || [])
    .map(code => code.trim())
    .filter(Boolean); // removes empty strings

  const descriptionLength = String(fields.description || "").trim().length;
  if (descriptionLength > 100) {
    errors.description = "Short Description must not be more than 100 characters";
  }

  if (codes.length === 0) {
    errors.code = "At least one promo code is required";
  } else {
    const invalidCode = codes.find(code => code.length < 6);
    if (invalidCode) {
      errors.code = "Each promo code must be at least 6 characters long";
    }
  }
     return { errors, isValid: isEmptyObject(errors) };
}